module.exports = __webpack_public_path__ + "static/img/openaccess_socialmedia_thumbnail.13a0240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/datastories/openaccess_socialmedia_thumbnail.png
// module id = zds5
// module chunks = 6